module.exports = __webpack_public_path__ + "static/media/stretch_film_dispenser.1c5412e1.png";